import * as React from "react";

import { component } from "Agile/Scripts/Common/Components/ComponentRegistration";
import { SprintViewCommonViewActions } from "Agile/Scripts/SprintsHub/SprintView/Components/SprintViewCommonViewActions";
import { SprintViewPivotBase } from "Agile/Scripts/SprintsHub/SprintView/Components/SprintViewPivotBase";
import { ISprintViewPivotContext } from "Agile/Scripts/SprintsHub/SprintView/SprintContentViewContracts";
import { IPivotBarViewAction, PivotBarViewActionArea } from "VSSUI/PivotBar";
import { LWPComponent } from "VSSPreview/Flux/Components/LWP";
import { HubViewActions } from "Agile/Scripts/Common/HubViewActions";
import { getBurndownProps, SprintBurndownProps } from "Agile/Scripts/Common/Components/BurndownReportPropsHelper";

interface SprintViewAnalyticsPivotState {
    lastRefresh?: Date;
    
    /** Describes if page has finished initial load. */
    isDataReady: boolean;
 }

@component("sprint-analytics-pivot")
export class SprintAnalyticsPivot extends SprintViewPivotBase<SprintViewAnalyticsPivotState> {

    constructor(props: ISprintViewPivotContext, context: any) {
        super(props, context);
        this.state = {
            isDataReady: false,
        };        
    }

    public isDataReady(): boolean {
        return this.state.isDataReady;
    }

    protected shouldUpdateViewActionsOnUpdate(nextProps: ISprintViewPivotContext, nextState: SprintViewAnalyticsPivotState): boolean {
        return true;
    }

    public getViewActions(props: ISprintViewPivotContext, state: SprintViewAnalyticsPivotState): IPivotBarViewAction[] {
        //  No pivot-specific actions for Analytics pivot, so returning only common view actions.
        const actions =  [
            ...SprintViewCommonViewActions.getSprintPickerViewActions(this.props.selectedIteration.name, this.props.onSprintPickerClicked),
            HubViewActions.getRefreshAction(this.onRefreshClick, PivotBarViewActionArea.farRight)
        ];
        return actions;
    }

    public render(): JSX.Element {
        //Note: Only Sprint Burndown belongs in Sprints view
        let reportSettings: SprintBurndownProps = getBurndownProps(this.props);
        reportSettings.lastRefresh= this.state.lastRefresh;
        reportSettings.onLoadCompleted = this.onLoadCompleted;
        return (
            < div className="sprint-analytics-content analytics-report-container" >
                {renderBurndownReport(reportSettings)}
            </div>
        );
    }
    
    public onRefreshClick = () : void => {
        this.setState({ lastRefresh: new Date() });
    }

    public onLoadCompleted = () : void => {
        this.setState({ isDataReady: true });
    }
}

function renderBurndownReport(reportSettings): JSX.Element {
    return <LWPComponent
        key={"burndown-report"}
        wrappedType={"BurndownReport"}
        dependencies={["ms.vss-reporting-web.burndown-report-content"]}
        {...reportSettings}
    />;
}
